import policyMedicinesCheckList from "./kardex-dif-check-list/Kardex-difCheckList.vue";
import i18n from "../../i18n/index";
import locationService from "../../services/location/LocationService.js";
import vademecumService from "../../services/asegurator/asegurator-medicine.js";
import providerService from '../../services/provider/ProviderService.js';
import vademecum from "../../services/policy/policy-medicine.js";
import branchService from "../../services/branch/BranchService.js";
import dayjs from "dayjs";

export default {
    components: {
        policyMedicinesCheckList,
    },
    data: () => ({
        headers: [
            { sortable: false, text: "PLU", value: "plu", align: "center" },
            {
                sortable: false,
                text: "Nombre",
                value: "description",
                align: "center",
            },
            {
                sortable: false,
                text: "Lote",
                value: "providerName",
                align: "center",
            },
            {
                sortable: false,
                text: "Fecha vencimiento",
                value: "providerName",
                align: "center",
            },
            { sortable: false, text: "Cantidad", value: "count", align: "center" },
        ],
        fechaAllowed: "",
        branches: [],
        vademecumData: [],
        hideList: false,
        editProccess: false,
        mun: {
            ActiveIngredient: "",
            descriptionActiveIngredient: "",
            nameTrade: "",
            pluCode: "",
            quantity: 0,
            isApplicable: false,
            isRegulated: false,
            active: true,
            provider: 0,
        },
        branch: {
            editFunction: false,
            id: "",
            name: "",
            branchId: "",
            providerId: "",
            type: "",
            branchCities: [],
            listCities: [],
            inactiveCities: [],
            newBranches: [],
        },
        menuDelivery: false,
        menuDeliveryven: false,
        medicine: {
            date: "",
            medicine: "",
            lote: "",
            dateVen: "",
            quantity: 0,
        },
        update: 0,
        rules: [
            (value) => !!value || i18n.t("field-required"),
            (v) => !v || v.length <= 200 || "Máximo 200 dígitos",
        ],

        numberRules: [
            (value) => !!value || i18n.t("field-required"),
            (v) => !v || v.length <= 10 || "Máximo 10 dígitos",
            (v) => !v || /^\d+$/.test(v) || "Solo números",
            // incluye aquí cualquier otra regla que necesites...
        ],
        validForm: true,
        loadingSaveButton: false,
        loadingDelete: false,
        showDelete: false,
        providers: [],
    }),
    created() {
        // this.getProviders();
        // this.getMedicines();
        // this.getBranches();
        // this.gettoday();
    },
    methods: {
        gettoday() {
            // Obtener la fecha actual
            const today = new Date();
            this.fechaAllowed = dayjs(today).format("YYYY-MM-DD");
            this.medicine.date = this.fechaAllowed;

        },
        getMedicines() {
            vademecum.getVademecumOrder().then((response) => {
                this.vademecumData = response.data;
                for (let index = 0; index < this.vademecumData.length; index++) {
                    const medicine = this.vademecumData[index];
                    if (medicine.isApplicable || medicine.isWatched) {
                        this.vademecumData[index].disabled = true;
                    }
                }
                return this.vademecumData;
            });
        },
        async getBranches() {
            let response = await branchService.allBranchesPolicy();
            this.branches = response.data[0];
        },
        closeCreate() {
            this.hideList = false;
            this.branch.editFunction = false;
            this.branch.branchId = null;
            this.branch.branchCities = [];
            this.branch.listCities = [];
            this.branch.inactiveCities = [];
            this.showFunction();
          },
        save() {
            if (!this.$refs.municipioform.validate()) {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: i18n.t("app.error-required-fields"),
                });
                return;
            }
            // this.mun.id = this.mun.id == '' ? this.$refs.munipicioList.getLenght() + 1 : this.mun.id;
            this.editProccess = false;
            vademecumService
                .createVademecun(this.mun)
                .then((result) => {
                    if (result.status == 200) {
                        this.$notify({
                            group: "app",
                            type: "success",
                            text: i18n.t("record-successfully-created"),
                        });
                    }
                    this.$refs.municipioList.searchCity();
                    this.closeUser();
                })
                .catch((err) => {
                    throw err;
                });
        },
        async getProviders() {
            return await providerService.getProviders().then(response => {
                this.providers = response.data;
            });
        },
    },
};